import React from "react";
import {connect} from "react-redux";
import {Select, Form, Input, message, Modal, Button, Space, Alert, Tooltip} from "antd";
import {createEmailAddress} from "../../actions/domains";
import {displayErrors} from "../../libs/utils";
import {randomPassword} from "../../libs/credentials_generator";
import RetweetOutlined from "@ant-design/icons/lib/icons/RetweetOutlined";
import {CopyOutlined} from "@ant-design/icons";

class EmailAddressModal extends React.Component {
    state = {
        loading: false,
        emailAddress: '',
        emailAddressType: 'FORWARDER',
        forwardToEmailAddress: '',
        password: randomPassword(),
        isCatchall: false
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    closeModal() {
        this.setState( {
            loading: false,
            emailAddress: '',
            emailAddressType: 'FORWARDER',
            forwardToEmailAddress: '',
            password: '',
            isCatchall: false
        });

        this.props.closeModal();
    }

    saveEmailAddress() {
        this.setState({ loading: true });

        let data = {
            'email_address': this.state.emailAddress.trim() + '@' + this.props.domainName,
            'email_address_type': this.state.emailAddressType.trim(),
            'is_catchall': this.state.isCatchall
        };

        if(this.state.emailAddressType === 'FORWARDER') {
            data['forward_to_email_address'] = this.state.forwardToEmailAddress.trim().toLocaleLowerCase();
        } else if(this.state.emailAddressType === 'MAILBOX') {
            data['password'] = this.state.password;
        }

        this.props.createEmailAddress(this.props.domain, data, () => {
            this.setState({ loading: false });
            message.success('Email address successfully created!');

            this.props.reloadEmailAddresses();
            this.closeModal();

        }, (err) => {
            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
                this.setState({ loading: false });
            }
        });
    }

    setEmailAddress(e) {
        let value = e.target.value.trim().toLowerCase();
        this.setState({ emailAddress: value, isCatchall: value === '*' });
    }

    render() {
        const { Option } = Select;

        return(
            <Modal
                centered
                title={'Add Email Address'}
                open={this.props.showModal}
                onCancel={() => this.closeModal()}
                destroyOnClose={true}
                footer={<Space>
                    <Button onClick={() => this.closeModal()} disabled={this.state.loading}>Close</Button>
                    <Button type='primary' onClick={() => this.saveEmailAddress()} disabled={this.state.loading} loading={this.state.loading}>Create</Button>
                </Space>}>
                {this.props.hostingType !== 'SHARED_HOSTING' ? <Alert style={{marginBottom: '10px'}} showIcon={true} type='info' message={<span>Mailbox type is only available with shared hosting accounts!</span>} /> : ''}

                <Form layout='vertical'>
                    <Form.Item label='Type'>
                        <Select value={this.state.emailAddressType} onChange={(value) => this.setState({ emailAddressType: value })}>
                            <Option value='FORWARDER'>Forwarder</Option>
                            <Option disabled={this.props.hostingType !== 'SHARED_HOSTING'} value='MAILBOX'>Mailbox in hosting account</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label='Email address' extra={<small>Valid characters: a-z, 0-9, * for catch-all</small>}>
                        <Input value={this.state.emailAddress} onChange={(e) => this.setEmailAddress(e)} addonAfter={'@' + this.props.domainName} />
                    </Form.Item>
                    {this.state.emailAddressType === 'FORWARDER' ? <>
                        <Form.Item label='Forward to email address' extra={<small>Enter full email address like: username@domain.tld</small>}>
                            <Input value={this.state.forwardToEmailAddress} type='email' onChange={(e) => this.setState({ forwardToEmailAddress: e.target.value })} />
                        </Form.Item>
                        <Alert showIcon={true} type='warning' message='We do not recommend using Gmail emails as destinations because of their aggressive spam protection.' />
                    </> : ''}
                    {this.state.emailAddressType === 'MAILBOX' ? <>
                        <Form.Item label='Password' extra={<small>Password to use for your mailbox.</small>}>
                            <Input
                                value={this.state.password}
                                suffix={<Space>
                                    <Tooltip title='Generate password'>
                                        <RetweetOutlined onClick={() => this.setState({ password: randomPassword()})} />
                                    </Tooltip>
                                    <Tooltip title='Copy password'>
                                        <CopyOutlined
                                            onClick={() => {
                                                navigator.clipboard.writeText(this.state.password);
                                                message.success('Password copied');
                                            }}
                                        />
                                    </Tooltip>
                                </Space>}
                                onChange={() => false}
                                />
                        </Form.Item>
                        <Alert showIcon={true} type='warning' message={<span>When sending emails from cPanel, your shared hosting account's IP address will be shown in email headers!</span>} />
                    </> : '' }
                </Form>

            </Modal>
        );
    }
}

export default connect(null, { createEmailAddress })(EmailAddressModal);